import { fetchApi } from '../../../lib/fetchApi';
import { TopicStatistics } from '../types';
import { SelectedFilter } from '../../../components/Filters/types';
import { FilterDto } from '../../../types/FilterDto';
import { TreeSelectItemDto } from '../../../types/SelectItemDto';
import { PaginationFilterDto } from '../../../types/Pagination';

const BASE_URL = "/topics";

export const getTopicsForSurvey = async (filters: SelectedFilter[]): Promise<TopicStatistics[]> => {
    const response = await fetchApi.post(`${BASE_URL}/bySurvey`, filters) as TopicStatistics[] ;
  return response;
}

export const getTopicsClaims = async (filters: PaginationFilterDto): Promise<TopicStatistics[]> => {
    const response = await fetchApi.post(`${BASE_URL}/byClaim`, filters) as TopicStatistics[];
    return response;
}

export const getTopicFilter = async (): Promise<FilterDto> => {
    const response = await fetchApi.get(`${BASE_URL}/filter`) as FilterDto;
    return response;
}

export const getTopicsSelect = async (): Promise<TreeSelectItemDto[]> => {
    const response = await fetchApi.get(`${BASE_URL}/select`) as TreeSelectItemDto[];
    return response;
}